import { render, staticRenderFns } from "./topPiece.vue?vue&type=template&id=0b0816d4&scoped=true&"
import script from "./topPiece.vue?vue&type=script&lang=js&"
export * from "./topPiece.vue?vue&type=script&lang=js&"
import style0 from "./topPiece.vue?vue&type=style&index=0&id=0b0816d4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b0816d4",
  null
  
)

export default component.exports